(() => {
  const initialize = (root = document) => root.querySelectorAll('[data-rf-carousel]').forEach(carousel => {
    if (carousel.dataset.ready) return;
    carousel.dataset.ready = 'true';
    // Include the delivery banner as well as the navigation in viewport sizing.
    const header = document.getElementById('shopify-section-header');
    const measureHeader = () => carousel.style.setProperty('--rf-header-height', `${Math.ceil(header?.getBoundingClientRect().height || 0)}px`);
    measureHeader();
    if (header) new ResizeObserver(measureHeader).observe(header);
    const slides = [...carousel.querySelectorAll('[data-rf-slide]')];
    const dots = [...carousel.querySelectorAll('[data-rf-dot]')];
    let index = 0;
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    let paused = motion.matches;
    let timer;
    const toggle = carousel.querySelector('[data-rf-pause]');
    const schedule = () => {
      clearInterval(timer);
      // Never rotate away from a focused shopping link. Controls stay visible
      // across slides, so focusing Play must not prevent playback.
      const focusedSlide = document.activeElement?.closest('[data-rf-slide]');
      if (!paused && !document.hidden && !(focusedSlide && carousel.contains(focusedSlide))) timer = setInterval(() => show(index + 1), 5000);
    };
    const show = next => {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => { slide.hidden = i !== index; });
      dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === index)));
      carousel.querySelector('.rf-slide-status').textContent = `Slide ${index + 1} of ${slides.length}`;
    };
    carousel.querySelector('.rf-carousel-controls').hidden = false;
    const updateToggle = () => { toggle.textContent = paused ? '▶' : 'Ⅱ'; toggle.setAttribute('aria-label', paused ? 'Play slideshow' : 'Pause slideshow'); };
    toggle.addEventListener('click', () => { paused = !paused; updateToggle(); schedule(); });
    carousel.addEventListener('focusin', schedule);
    carousel.addEventListener('focusout', () => setTimeout(schedule, 0));
    document.addEventListener('visibilitychange', schedule);
    motion.addEventListener('change', () => { paused = motion.matches; updateToggle(); schedule(); });
    updateToggle(); schedule();
    carousel.querySelector('[data-rf-prev]').addEventListener('click', () => show(index - 1));
    carousel.querySelector('[data-rf-next]').addEventListener('click', () => show(index + 1));
    dots.forEach((dot, i) => dot.addEventListener('click', () => show(i)));
    carousel.querySelector('.rf-carousel-controls').addEventListener('keydown', event => {
      if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault(); show(index + (event.key === 'ArrowRight' ? 1 : -1)); dots[index].focus();
    });
  });
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
